module.exports = __webpack_public_path__ + "img/check-circle.3bc45693.svg";